<div class="page-wrapper">

  <!-- FORMULARIO -->
  <ng-container *ngIf="!submitted">
    <picture>
      <source media="(max-width: 768px)" [srcset]="formImageMobileUrl" />
      <img [src]="formImageUrl" class="bg-image" alt="Formulario" />
    </picture>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="fields-overlay">

      <!-- NOMBRE -->
      <div class="field-wrapper field-nombre">
        <input
          formControlName="nombre"
          type="text"
          placeholder="Nombre"
          class="field-input"
          [class.invalid]="form.get('nombre')?.invalid && form.get('nombre')?.touched"
        />
        <span class="error-msg" *ngIf="form.get('nombre')?.invalid && form.get('nombre')?.touched">
          Campo obligatorio
        </span>
      </div>

      <!-- CÉDULA -->
      <div class="field-wrapper field-cedula">
        <input
          formControlName="cedula"
          type="text"
          placeholder="Cédula"
          class="field-input"
          [class.invalid]="form.get('cedula')?.invalid && form.get('cedula')?.touched"
        />
        <span class="error-msg" *ngIf="form.get('cedula')?.invalid && form.get('cedula')?.touched">
          Campo obligatorio
        </span>
      </div>

      <!-- TELÉFONO -->
      <div class="field-wrapper field-celular">
        <input
          formControlName="celular"
          type="tel"
          placeholder="Teléfono"
          class="field-input"
          maxlength="10"
          [class.invalid]="form.get('celular')?.invalid && form.get('celular')?.touched"
        />
        <span class="error-msg" *ngIf="form.get('celular')?.touched">
          <ng-container *ngIf="form.get('celular')?.hasError('required')">Campo obligatorio</ng-container>
          <ng-container *ngIf="form.get('celular')?.hasError('pattern')">Debe tener exactamente 10 dígitos</ng-container>
        </span>
      </div>

      <!-- CORREO -->
      <div class="field-wrapper field-correo">
        <input
          formControlName="correo"
          type="email"
          placeholder="Correo"
          class="field-input"
          [class.invalid]="form.get('correo')?.invalid && form.get('correo')?.touched"
        />
        <span class="error-msg" *ngIf="form.get('correo')?.touched">
          <ng-container *ngIf="form.get('correo')?.hasError('required')">Campo obligatorio</ng-container>
          <ng-container *ngIf="form.get('correo')?.hasError('email')">Correo no válido</ng-container>
        </span>
      </div>

      <button type="submit" class="btn-agregar">AGREGAR</button>
    </form>
  </ng-container>

  <!-- AGRADECIMIENTO -->
  <div *ngIf="submitted" class="thanks-wrapper">
    <picture>
      <source media="(max-width: 768px)" [srcset]="thanksImageMobileUrl" />
      <img [src]="thanksImageUrl" class="bg-image" alt="Gracias" />
    </picture>
  </div>

</div>
